import React from 'react';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { Fade } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import TextError from 'components/TextError';

const useStyles = makeStyles(({ spacing, palette, breakpoints, status }) => ({
  root: {
    width: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: spacing(6),
    [breakpoints.up(400 + spacing(6))]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  paper: {
    marginTop: spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${spacing(2)}px ${spacing(3)}px ${spacing(3)}px`
  },
  avatar: {
    margin: spacing(1),
    backgroundColor: palette.primary.dark
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: spacing(1)
  },
  divider: {
    margin: spacing(2)
  },
  successText: {
    margin: spacing(1),
    color: status.success
  }
}));

const SimpleForm = ({ title, children, errorText, successText = null, footer = null, onSubmit }) => {
  const classes = useStyles({})
;

  const onFormSubmit = event => {
    event.preventDefault();
    onSubmit();
  };

  return (
    <Fade in={true}>
      <div className={classes.root}>
        <Typography variant="h5">{title}</Typography>
        <form className={classes.form} onSubmit={onFormSubmit}>
          {children}
          {errorText && <TextError>{errorText}</TextError>}
          {successText && (
            <Typography className={classes.successText} variant="caption" align="center" gutterBottom>
              {successText}
            </Typography>
          )}
          {footer && <Divider variant="middle" className={classes.divider} />}
          {footer}
        </form>
      </div>
    </Fade>
  );
};

export default SimpleForm;
